import {
  FETCH_WAREHOUSE_ORDER_LIST,
  RESET_WAREHOUSE_ORDER_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {
    total: 0,
    offset: 0,
    limit: 10,
  },
};

const warehouseOrderListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WAREHOUSE_ORDER_LIST:
      return { list: action.payload, others: action.others };
    case RESET_WAREHOUSE_ORDER_LIST:
      return initialState;
    default:
      return state;
  }
};

export default warehouseOrderListReducer;
